import Vue from 'vue'
import { formatDate } from "./formatDate"
let { entries } = Object
// clone
export const clone = function (item) {
    if (!item) {
        return item
    } // null, undefined values check
    return JSON.parse(JSON.stringify(item))
}

export const isArray = (arr) => {
    return Object.prototype.toString.call(arr) === '[object Array]'
}

export const isObject = (arr) => {
    return Object.prototype.toString.call(arr) === '[object Object]'
}

export const isUndefined = (arr) => {
    return Object.prototype.toString.call(arr) === '[object Undefined]'
}

export const isRegex = (reg) => {
    return Object.prototype.toString.call(reg) === '[object RegExp]'
}
export const eventBus = new Vue()

export { formatDate as formatDate}

export const pick = (obj = {}, keys = []) => {
    let result = {}
    for (let [key, value] of entries(obj)) {
        if (keys.indexOf(key) > -1) {
            result[key] = value
        }
    }
    return result
}



// WEBPACK FOOTER //
// ./src/helpers/index.js